import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { PublicClientApplication } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'

import './index.css'

import { msalConfig } from './auth/msalConfig'
import { ApiContext } from './hooks/useApi'
import { useApiContextValue } from './hooks/useApi'
import ProtectedRoute from './components/ProtectedRoute'
import Layout from './components/Layout'
import Dashboard from './pages/Dashboard'
import Projects from './pages/Projects'
import ProjectDetail from './pages/ProjectDetail'
import AddProject from './pages/AddProject'
import Reports from './pages/Reports'
import Settings from './pages/Settings'
import SettingsAdmin from './pages/SettingsAdmin'
import SettingsAudit from './pages/SettingsAudit'
import SettingsPermissions from './pages/SettingsPermissions'
import SettingsReporting from './pages/SettingsReporting'
import Products from './pages/Products'
import ProductDetail from './pages/ProductDetail'
import Survey from './pages/Survey'
import AsanaCallback from './pages/AsanaCallback'
import Scorecard from './pages/Scorecard'
import ProjectReport from './pages/ProjectReport'
import FeatureRequest from './pages/FeatureRequest'
import BAU from './pages/BAU'
import MonthEndReview from './pages/MonthEndReview'
import DdiPortfolio from './pages/DdiPortfolio'
import SurveyResults from './pages/SurveyResults'
import Feedback from './pages/Feedback'
import SettingsSurveys from './pages/SettingsSurveys'

const pca = new PublicClientApplication(msalConfig)

function App() {
  const apiCtx = useApiContextValue()

  return (
    <ApiContext.Provider value={apiCtx}>
      <Routes>
        {/* Public routes (no auth required) */}
        <Route path="/survey/:projectToken/:recipientToken" element={<Survey />} />
        <Route path="/feedback/:roundId" element={<Feedback />} />
        <Route path="/asana-callback" element={<AsanaCallback />} />

        {/* Protected routes */}
        <Route element={<ProtectedRoute />}>
          <Route element={<Layout />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/projects/new" element={<AddProject />} />
            <Route path="/projects/:id" element={<ProjectDetail />} />
            <Route path="/projects/:id/report" element={<ProjectReport />} />
            <Route path="/products" element={<Products />} />
            <Route path="/products/:id" element={<ProductDetail />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/scorecard" element={<Scorecard />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/settings/admin" element={<SettingsAdmin />} />
            <Route path="/settings/permissions" element={<SettingsPermissions />} />
            <Route path="/settings/reporting" element={<SettingsReporting />} />
            <Route path="/settings/surveys" element={<SettingsSurveys />} />
            <Route path="/settings/audit" element={<SettingsAudit />} />
            <Route path="/feature-request" element={<FeatureRequest />} />
            <Route path="/bau" element={<BAU />} />
            <Route path="/survey-results" element={<SurveyResults />} />
            <Route path="/month-end" element={<MonthEndReview />} />
            <Route path="/ddi" element={<DdiPortfolio />} />
          </Route>
        </Route>
      </Routes>
    </ApiContext.Provider>
  )
}

pca.initialize().then(() => {
  pca.handleRedirectPromise().then(() => {
    ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
      <React.StrictMode>
        <MsalProvider instance={pca}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </MsalProvider>
      </React.StrictMode>,
    )
  })
})
